// @flow
import React from 'react';

const Loading = ({ isLoading }: { isLoading: boolean }) =>
  isLoading ? <div className="overlay loading" /> : null;

export default Loading;
